import  {combineReducers} from  'redux'
import { reducer as formReducer } from 'redux-form'

// Reducers
import auth from './reducers/auth'

import companies from './reducers/companies'
import users from './reducers/users'
import roles from './reducers/roles'
import reducer from './redux-api-handler/reducer'



const rootReducers = combineReducers({
  form: formReducer,
  api: reducer,
  companies,
  users,
  auth,
  roles
});


export default rootReducers;



// WEBPACK FOOTER //
// ./src/redux/rootReducer.js